export function getCookie(name) {
    let matches = document.cookie.match(new RegExp(// eslint-disable-line
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"// eslint-disable-line
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}

export function setCookie(name, value, options = {"max-age": 31536000}) {// eslint-disable-line
    options = {// eslint-disable-line
      path: '/',
      // при необходимости добавьте другие значения по умолчанию
      ...options
    };
    if (options.expires instanceof Date) {
      options.expires = options.expires.toUTCString();// eslint-disable-line
    }// eslint-disable-line
    let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);// eslint-disable-line
    for (let optionKey in options) {// eslint-disable-line
      updatedCookie += "; " + optionKey;// eslint-disable-line
      let optionValue = options[optionKey];// eslint-disable-line
      if (optionValue !== true) {
        updatedCookie += "=" + optionValue;// eslint-disable-line
      }
    }
    document.cookie = updatedCookie;
}

export function deleteCookie(name) {
    setCookie(name, '', {
      'max-age': -1// eslint-disable-line
    });
}
